import React, { useCallback, useMemo, useState } from 'react';
import { Card, Button, Icon } from 'tea-component';
import { ECHARTS_OPTION_EXAMPLES, EXAMPLE_DATA } from '../../constants/examples';
import { TTestMode } from '../../types';
import './index.scss';

interface IExampleSelectorProps {
  mode: TTestMode;
  onSelect: (data: string) => void;
}

const ExampleSelector = React.memo(({ mode, onSelect }: IExampleSelectorProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const list = useMemo(() => {
    return mode === 'echartsOption' ? ECHARTS_OPTION_EXAMPLES : EXAMPLE_DATA;
  }, [mode]);

  const title = mode === 'echartsOption' ? '原生 ECharts 示例' : 'biData 示例';

  const handleSelect = useCallback(
    (data: string) => {
      onSelect(data);
      setIsExpanded(false);
    },
    [onSelect],
  );

  const handleToggleExpand = useCallback(() => {
    setIsExpanded((prev) => !prev);
  }, []);

  return (
    <Card className="dba-example-selector-container">
      <Card.Header>
        <div
          className="dba-example-selector-header"
          onClick={handleToggleExpand}
        >
          <h3>{title}</h3>
          <Icon type={isExpanded ? 'arrowup' : 'arrowdown'} />
        </div>
      </Card.Header>
      {isExpanded && (
        <Card.Body>
          <div className="dba-example-list">
            {list.map((example) => (
              <div key={`${mode}-${example.name}`} className="dba-example-item">
                <div className="dba-example-item-header">
                  <span className="dba-example-item-name">{example.name}</span>
                  <Button
                    type="link"
                    size="s"
                    onClick={() => handleSelect(example.data)}
                  >
                    加载
                  </Button>
                </div>
                <p className="dba-example-item-description">{example.description}</p>
              </div>
            ))}
          </div>
        </Card.Body>
      )}
    </Card>
  );
});

ExampleSelector.displayName = 'ExampleSelector';

export default ExampleSelector;
